module.exports = __webpack_public_path__ + "static/img/tyre-left.bd48abb8.png";